import React from "react"
import { Card } from "antd"
import styles from "./CardProgram.module.css"


const CardProgram = (props) => {

  const { image, title, desc } = props;

  return (
    <>
      <Card
        variant="borderless"
        // data-aos="fade-up"
        className={styles.cardProgram}
        cover={
          <img
            draggable={false}
            alt="example"
            src={image}
            className={styles.cardImage}
          />
        }>
        <h3>{title}</h3>
        <h5>{desc}</h5>
      </Card>
    </>
  )
}
export default CardProgram